/**
 * StationModeInfoTip — Wraps the Station Mode button: hovering or focusing it shows what the mode
 * does, and clicking it closes the note (InfoPopover describe mode).
 */

import InfoPopover from '../../../../components/v2/InfoPopover.jsx';

const STATION_TOOLTIP = [
    'Station Mode provides a full-screen view that displays only alerts for',
    'devices that have not yet been cleared. It is designed for use on dedicated',
    'nurse stations and wall-mounted view boards.',
];

const StationModeInfoTip = ({ children }) => (
    <InfoPopover mode="describe" marker="none" heading="About Station Mode" body={STATION_TOOLTIP.join(' ')}>
        {children}
    </InfoPopover>
);

export default StationModeInfoTip;
